
export default class SearchForm {
    
    static get selector() {
        return '.header__searchForm, .searchForm__form';
    }

    constructor(el) {
        this.form = el;
        this.input = this.form.querySelector('.header__searchFormInput, .searchForm__input');
        this.setEvents();
    }

    search() {
        let url = this.form.action+'?s=' + this.input.value;
        
        window.location = url;

        /* window.dispatchEvent( new CustomEvent('vegout-redirect', {
            detail: {
              url: url
            }
        })); */
    }

    setEvents() {
        this.form.addEventListener('submit', this.e_submit.bind(this));
    }

    e_submit( e ) {
        e.preventDefault();
        this.search();
    }

}